/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InovalonPayer } from './InovalonPayer';
import {
    InovalonPayerFromJSON,
    InovalonPayerFromJSONTyped,
    InovalonPayerToJSON,
} from './InovalonPayer';

/**
 * 
 * @export
 * @interface GetInovalonPayerList200Response
 */
export interface GetInovalonPayerList200Response {
    /**
     * 
     * @type {Array<InovalonPayer>}
     * @memberof GetInovalonPayerList200Response
     */
    data?: Array<InovalonPayer>;
}

/**
 * Check if a given object implements the GetInovalonPayerList200Response interface.
 */
export function instanceOfGetInovalonPayerList200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetInovalonPayerList200ResponseFromJSON(json: any): GetInovalonPayerList200Response {
    return GetInovalonPayerList200ResponseFromJSONTyped(json, false);
}

export function GetInovalonPayerList200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInovalonPayerList200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InovalonPayerFromJSON)),
    };
}

export function GetInovalonPayerList200ResponseToJSON(value?: GetInovalonPayerList200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InovalonPayerToJSON)),
    };
}

